<app-before-login-logo></app-before-login-logo>

<div class="login-clean login-page">
  <ng-container *ngIf="showOtpForm; else browserTemplate">
    <form method="post">
      <h4 class="text-center">二要素認証</h4>
      <div class="illustration">
        <i class="fa fa-lock login-icon"></i>
      </div>
      <p class="description">認証アプリに表示されている認証コードを入力してください。</p>

      <div class="form-group">
        <input class="form-control" type="text" name="otpAttempt" placeholder="認証コード" [(ngModel)]="otpAttempt">
      </div>
      <div class="form-group">
        <button class="btn btn-primary-dark btn-block" type="submit" (click)="verify()">認証する</button>
      </div>

      <a href="#" class="forgot text-right" (click)="cancel($event)">キャンセル</a>
    </form>
  </ng-container>

  <ng-template #browserTemplate>
    <ng-container *ngIf="showBrowserForm;else loginTemplate">
      <app-session-browser
        [loginForm]="loginForm"
        [browsers]="browsers"
        (afterBrowserRegister)="afterBrowserRegister($event)"
        (cancelBrowserRegister)="cancel($event)">
      </app-session-browser>
    </ng-container>
  </ng-template>

  <ng-template #loginTemplate>
    <form method="post" class="login-form">
      <div class="illustration">
        <i class="fa fa-user-circle-o login-icon"></i>
      </div>

      <div class="form-group">
        <input class="form-control" type="email" name="email" placeholder="メールアドレス" [(ngModel)]="email" />
      </div>
      <div class="form-group">
        <input class="form-control" type="password" name="password" placeholder="パスワード" [(ngModel)]="password" />
      </div>
      <div class="form-group position-relative">
        <button class="btn btn-primary-dark btn-block" type="submit" (click)="signIn()">ログイン</button>
      </div>

      <a href="/account/password/reset/mail" class="forgot text-right">パスワードを忘れた方はこちら</a>
    </form>
  </ng-template>
</div>

<app-footer></app-footer>
